module.exports = __webpack_public_path__ + "img/20200115155913360截图20200115111946466.a46a5e20.jpg";